import { BiometricsFlowType, BiometricsStoreItem } from './enums/consts';
import Container, { Service } from 'typedi';
import { MessageBroker, NativeChannel, SessionChannel } from '@sparkware/uc-sdk-core';
import { WebLoginService } from '../web-login/web.login.service';
import { FIT_TO_PLAY_BRANDS } from '../../models/enums/general-enums';
import { LocalSimpleStoreService } from '../storage/implementations/simple-store';
import { TypeUtils } from '../../../Modules/Utils/TypeUtils';
import { INativeService } from '../native/models/INativeService';
import { IBiometricsFlowSettings } from './models';
import { LoaderManager } from '../../loaders/LoaderManager';
import { WindowToken } from '../../injection-tokens';

@Service()
export class BiometricsUtils {
    private readonly _window: Window;
    private readonly _nativeChannel: NativeChannel;
    private readonly _sessionChannel: SessionChannel;
    private readonly _localStorageItemService: LocalSimpleStoreService;

    private get _nativeServicePromise(): Promise<INativeService> {
        return LoaderManager.Instance.NativeServiceLoader.Instance;
    }

    constructor() {
        this._window = Container.get(WindowToken);
        this._nativeChannel = MessageBroker.getInstance().native;
        this._sessionChannel = MessageBroker.getInstance().session;
        this._localStorageItemService = Container.get(LocalSimpleStoreService);
    }

    public FindIfIsEnrolled = (): boolean => {
        const isEnrolled = this._localStorageItemService.get(BiometricsStoreItem.IsEnrolled);

        return TypeUtils.toBoolean(isEnrolled);
    };

    public FindIfBiometricsFlowIsEnabled = async () => {
        const { isBiometricsNewFlowEnabled } = await this.GetBiometricsFlowSettings();

        return isBiometricsNewFlowEnabled;
    };

    public FindIfBiometricsNewFlowIsEnabled = async () => {
        const { isBiometricsNewFlowEnabled } = await this.GetBiometricsFlowSettings();

        return isBiometricsNewFlowEnabled;
    };

    public GetBiometricsFlowSettings = async (): Promise<IBiometricsFlowSettings> => {
        let biometricsFlowSettings = {
            biometricsFlowType: null,
            isBiometricsFlowEnabled: false,
            isBiometricsNewFlowEnabled: false,
        };

        const nativeService = await this._nativeServicePromise;
        if (nativeService) {
            const { isBiometricsNewFlowEnabled } = nativeService.getBiometricsFlowSettings();
            biometricsFlowSettings.isBiometricsFlowEnabled = isBiometricsNewFlowEnabled;
            biometricsFlowSettings.isBiometricsNewFlowEnabled = isBiometricsNewFlowEnabled;

            biometricsFlowSettings.biometricsFlowType =
                biometricsFlowSettings.isBiometricsFlowEnabled
                    ? isBiometricsNewFlowEnabled
                        ? BiometricsFlowType.Biometrics
                        : BiometricsFlowType.TouchId
                    : null;
        }
        return biometricsFlowSettings;
    };

    public IsFitToPlay = async (): Promise<boolean> => {
        return new Promise<boolean>(async (resolve) => {
            const brandId = this._window.pageContextManager.getBrandData().brandId;
            const isFitToPlayEnabled = FIT_TO_PLAY_BRANDS.some((brand) => brand === brandId);
            const { isBiometricsNewFlowEnabled } = await this.GetBiometricsFlowSettings();
            const isEnrolled = this.FindIfIsEnrolled();
            if (!(isFitToPlayEnabled && isBiometricsNewFlowEnabled && isEnrolled)) {
                return resolve(true);
            }
            const userIsFitToPlaySub = this._nativeChannel.topics.userIsFitToPlay.subscribe(() => {
                resolve(true);
                userIsFitToPlaySub.unsubscribe();
            });
            const webLoginClosedSub = this._sessionChannel.topics.webLoginClosed.subscribe(() => {
                resolve(false);
                webLoginClosedSub.unsubscribe();
            });
            const webLoginService = Container.get(WebLoginService);
            webLoginService.ShowFitToPlay();
        });
    };
}
